<template>
    <div
        class="element-content"
        :style="elementStyle"
        @mouseover="onMouseOver"
        @mouseout="onMouseOut"
    />
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: 'InteractiveHotspot',
        data() {
            return {
                mouseOver: false,
            };
        },
        props: ['element'],
        computed: {
            ...mapGetters('interactive', ['activeElement']),
            elementStyle() {
                if (!this.element) {
                    return;
                }

                const styleState = this.mouseOver ? this.element.style.hover : this.element.style.default;

                const style = {
                    border: styleState.border.width + 'px solid ' + styleState.border.color,
                };

                if (styleState.background.color) {
                    style['background-color'] = styleState.background.color;
                }

                return style;
            },
        },
        methods: {
            onMouseOver() {
                this.mouseOver = true;
            },
            onMouseOut() {
                this.mouseOver = false;
            },

        }
    };
</script>

<style scoped>

</style>